// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__IQ6h4","descriptionTitle":"Description_descriptionTitle__bwPAL","descriptionContent":"Description_descriptionContent__pCRwU"};